var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8527 3.17719C22.5166 3.32117 22.2286 3.60911 22.0368 3.99315L20.0208 10.2332L17.8126 5.43323L17.3325 5.7694C10.9487 10.3293 7.68447 18.6334 9.07682 26.9854L1.01265 37.1134C0.868671 37.3053 0.868672 37.6414 1.10874 37.7854C1.20483 37.8333 1.30059 37.8815 1.39669 37.8815C1.54066 37.8815 1.68464 37.8336 1.78073 37.6896L9.84456 27.5616C19.7806 26.9375 27.8446 19.6896 29.4766 9.84962L31.1085 0.0576172L22.8527 3.17719ZM28.5166 9.7052C26.9807 18.8252 19.7326 25.5932 10.6606 26.5532L17.4287 18.0092C17.5726 17.8173 17.5726 17.4812 17.3326 17.3372C17.1407 17.1932 16.8045 17.1932 16.6606 17.4333L9.89283 25.9291C8.93292 18.4411 11.8609 11.1451 17.429 6.92105L20.1648 12.8731L22.901 4.28113C22.9489 4.18504 23.045 4.08928 23.1411 4.04106L29.8609 1.54498L28.5166 9.7052Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInk);
export default __webpack_public_path__ + "static/media/ink.331b73e5daedd95f25232d23f3eb25b3.svg";
export { ForwardRef as ReactComponent };